export enum TaggableDTO {
  NetworkShare = 'NetworkShare',
  Company = 'Company',
  User = 'User',
  Targeting = 'Targeting',
  SSPContract = 'SSPContract',
  Screen = 'Screen',
  PlaybackScheduleSlot = 'PlaybackScheduleSlot',
  ScreenHardware = 'ScreenHardware',
  Product = 'Product',
  PlayerHardware = 'PlayerHardware',
  CullCategory = 'CullCategory',
  Notification = 'Notification',
  ContentShareQuota = 'ContentShareQuota',
  Playlist = 'Playlist',
  Pool = 'Pool',
  Budget = 'Budget',
  MediumGroup = 'MediumGroup',
  Client = 'Client',
  CampaignType = 'CampaignType',
  MediumGroupCategory = 'MediumGroupCategory',
  PlayerSoftware = 'PlayerSoftware',
  Device = 'Device',
  Channel = 'Channel',
  Booking = 'Booking',
  Marker = 'Marker',
  Deal = 'Deal',
  Contact = 'Contact',
  Commercial = 'Commercial',
  Role = 'Role',
  Requirement = 'Requirement',
  SSP = 'SSP',
  Area = 'Area',
  Cull = 'Cull',
  Campaign = 'Campaign',
  Medium = 'Medium',
  ContentShare = 'ContentShare',
  ProductCategory = 'ProductCategory',
  PlaybackSchedule = 'PlaybackSchedule',
  Planning = 'Planning',
  AreaCategory = 'AreaCategory',
  LocationType = 'LocationType',
  NetworkPriceModel = 'NetworkPriceModel',
  Location = 'Location',
}
